<!-- Start Page Title Area -->

<div class="page-title-area page-title-bg1 upper-margin">
    <!-- data-aos="fade-up" data-aos-delay="100"-->
    <div class="container">
        <!--data-aos="fade-up" data-aos-delay="100"-->
        <div class="page-title-content mt-5">
            <h2>{{'Product_Details' | translate }}</h2>
            <!--<a routerLink="/">{{'Home' | translate }}</a>-->
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<!-- Start Products Details Area -->
<section class="product-details-area pt-100 pb-70">
    <div class="container">
        <div class="row" style="display: flex; justify-content: center; align-items: center;">
            <!--<div class="col-lg-5 col-md-12">
        <owl-carousel-o [options]="heroSlides">
            <ng-template carouselSlide *ngFor="let item of itemPictureData;">-->
            <!-- data-aos="zoom-in-up"-->
            <!--<div class="products-details-image">
                    <img [src]="apiURL + item.path" alt="products-image" />
                </div>
            </ng-template>
        </owl-carousel-o>


    </div>-->

            <div class="col-lg-5 col-md-12 col-12 product-wrapper">
                <owl-carousel-o [options]="heroSlides">
                    <ng-template carouselSlide *ngFor="let item of itemPictureData;">
                        <div class="product-image-wrapper">
                            <img [src]="apiURL + item.path" alt="products-image"/>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>


            <div class="col-lg-7 col-md-12 col-12">
                <div class="products-details-desc">
                    <!-- data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"-->
                    <h3>
                        <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                        </ng-template>
                        <ng-template #other_ItemAr>{{ mainForm.webNameAr }}</ng-template>
                        <ng-template #other_ItemEn>{{ mainForm.webNameEn }}</ng-template>
                    </h3>
                    <div class="price">
                        <ng-template *ngIf="mainForm.activateWebDiscount == true && mainForm.webDiscountFromDate < currentDate && mainForm.webDiscountToDate > currentDate ; then other_DiscountPrice; else  other_SalePrice">
                        </ng-template>

                        <ng-template #other_SalePrice>

                            <span class="new-price">{{ ((mainForm.saleTaxPercentage /100) * mainForm.salesPrice) + mainForm.salesPrice | number:'1.3-3' }} {{'OMR' | translate }} </span>

                        </ng-template>
                        <ng-template #other_DiscountPrice>

                            <span class="new-price">{{ ((mainForm.saleTaxPercentage /100) * mainForm.webDiscountAmount) + mainForm.webDiscountAmount | number:'1.3-3' }} {{'OMR' | translate }} </span>
                            <span class="old-price"> {{ ((mainForm.saleTaxPercentage /100) * mainForm.salesPrice) + mainForm.salesPrice | number:'1.3-3' }}</span>

                        </ng-template>

                    </div>


                    <ul class="products-info">
                        <li><span>{{'Availability' | translate }}: </span><b *ngIf="mainForm.isOutOfStock == false">{{'In_stock' | translate }}</b><b *ngIf="mainForm.isOutOfStock == true">{{'Out_of_stock' | translate }}</b></li>
                    </ul>


                    <p>
                        <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_DiscriptionAr  ; else other_DiscriptionEn">
                        </ng-template>
                        <ng-template #other_DiscriptionAr>{{ mainForm.descriptionAr }}</ng-template>
                        <ng-template #other_DiscriptionEn>{{ mainForm.description }}</ng-template>
                    </p>
                    <div class="products-meta">
                        <span>
                            <span>{{'Category' | translate }}: </span>
                            <a (click)="onCategoryChange(mainForm.gnCategoryID)" href="javascript:void(0);">
                                <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_categoryAr  ; else other_categoryEn">
                                </ng-template>
                                <ng-template #other_categoryAr>{{ mainForm.gnCategoryNameAr }}</ng-template>
                                <ng-template #other_categoryEn>{{ mainForm.gnCategoryName }}</ng-template>
                            </a>
                        </span>
                        <br />
                        <span>
                            <span>{{'Subcategory' | translate }}: </span>
                            <a (click)="onSubcategoryChange(mainForm.gnSubCategoryID)" href="javascript:void(0);">
                                <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_subcategoryAr  ; else other_subcategoryEn">
                                </ng-template>
                                <ng-template #other_subcategoryAr>{{ mainForm.subCategoryNameAr }}</ng-template>
                                <ng-template #other_subcategoryEn>{{ mainForm.subCategoryName }}</ng-template>
                            </a>
                        </span>
                        <br />
                        <span *ngIf="itemPieces > 0">
                            <span>{{'Sold' | translate }}: </span>
                            {{itemPieces}}  {{'Pieces' | translate }}
                        </span>
                        <br />
                        <span>
                            <span>{{'Barcode' | translate }}: </span>
                            {{mainForm.barcode}}
                        </span>
                    </div>
                    <br />

                    <div class="products-add-to-cart">
                        <div class="input-counter">
                            <span class="minus-btn"><i class='bx bx-minus'></i></span>
                            <input type="text" max="10" min="1" #qty id="qty" value="1">
                            <span class="plus-btn"><i class='bx bx-plus'></i></span>
                        </div>
                        <!-- *ngIf="mainForm.isOutOfStock == false"-->
                        <!--<button type="button" class="default-btn" (click)="addToCart(qty.value)"> {{'Add_to_Cart' | translate }}</button>-->
                        <button type="button" (click)="addToCart(qty.value)" class="cart-details-btn">{{'Add_To_Cart' | translate }} <i class='bx  bx-shopping-bag'></i></button>
                    </div>


                </div>
            </div>

        </div>
    </div>

    <section class="bg-color">
        <div class="containers">
            <div class="title">

                <p>{{'Our_Shop' | translate }}</p>
                <h1>{{'Related_Products' | translate }}</h1>
            </div>
            <div class="row" style="width: 100%; margin: auto;">
                <ngx-slick-carousel class="carousel"
                                    #slickModal="slick-carousel"
                                    [config]="slideConfig">
                    <div ngxSlickItem *ngFor="let item of dataSourceItems.data" class="slide">


                        <!-- data-aos="flip-right"-->
                        <div class="card d-flex flex-column m-2">
                            <div class="card-main">
                                <!--<div class="discount">9%</div>-->
                                <div class="label2 label-red mt-5" *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate">{{'Sales' | translate }}</div>
                                <div class="label label-green" *ngIf="item.newArrival == true && item.newArrivalFromDate < currentDate && item.newArrivalToDate > currentDate">{{'New' | translate }}</div>


                                <div class="d-flex" style="justify-content: center;" (click)="onClickItem(item.inItemID)">
                                    <img class="image" [src]="apiURL + item.photoPath" alt="Product" />
                                </div>
                                <br />
                                <div class="cart-line">
                                    <!--<div class="cart-item ">
                                        <a (click)="addToCart(item)" href="javascript:void(0);" class="icon-design" *ngIf="item.isOutOfStock == false"><i class="fa-solid fa-basket-shopping icon-design"></i>{{'Add_to_Cart' | translate }}</a>

                                    </div>-->
                                </div>
                            </div>

                            <div class="content">
                                <!-- *ngIf="item.isOutOfStock == false"-->
                                <div>
                                    <ng-template *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate ; then other_DiscountPrice; else  other_SalePrice">
                                    </ng-template>
                                    <ng-template #other_SalePrice>
                                        <div style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
                                            <span class="old-price-none"> {{'-'}}</span>
                                            <span class="money">{{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                        </div>


                                    </ng-template>
                                    <ng-template #other_DiscountPrice>
                                        <div style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
                                            <span class="old-price"> {{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }}</span>
                                            <span class="money">{{ ((item.saleTaxPercentage /100) * item.webDiscountAmount) + item.webDiscountAmount | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                        </div>



                                    </ng-template>

                                </div>
                                <div class="mt-2">
                                    <a class="item-name" href="javascript:void(0);" (click)="onClickItem(item.inItemID)">
                                        <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                        </ng-template>
                                        <ng-template #other_ItemAr>{{ item.webNameAr }}</ng-template>
                                        <ng-template #other_ItemEn>{{ item.webNameEn }}</ng-template>
                                    </a>
                                </div>

                                <div class="col-lg-12 col-md-12 mt-2">
                                    <button type="button" (click)="addToCart2(item)" class="cart-btn">{{'Add_To_Cart' | translate }} <i class='bx  bx-shopping-bag'></i></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>

        </div>


    </section>

</section>
<!-- End Products Details Area -->
